import * as types from "./types";

export const getCompanyClientsRequest = (payload) => ({
  type: types.GET_COMPANY_CLIENTS_REQUEST,
  payload,
});

export const getCompanyClientsResponse = (payload) => ({
  type: types.GET_COMPANY_CLIENTS_RESPONSE,
  payload,
});

export const getCompanyClientRequest = (payload) => ({
  type: types.GET_COMPANY_CLIENT_REQUEST,
  payload,
});

export const getCompanyClientResponse = (payload) => ({
  type: types.GET_COMPANY_CLIENT_RESPONSE,
  payload,
});

export const clearCompanyClient = () => ({
  type: types.CLEAR_COMPANY_CLIENT,
});

export const updateCompanyClientRequest = (payload) => ({
  type: types.UPDATE_COMPANY_CLIENT_REQUEST,
  payload,
});

export const updateCompanyClientResponse = (payload) => ({
  type: types.UPDATE_COMPANY_CLIENT_RESPONSE,
  payload,
});

export const createCompanyClientRequest = (payload) => ({
  type: types.CREATE_COMPANY_CLIENT_REQUEST,
  payload,
});

export const createCompanyClientSuccess = (payload) => ({
  type: types.CREATE_COMPANY_CLIENT_SUCCESS,
  payload,
});

export const createCompanyClientFailure = (payload) => ({
  type: types.CREATE_COMPANY_CLIENT_FAILURE,
  payload,
});
